import React from 'react';
import RangeIndicatorChart from './RangeIndicatorChart';

interface FormDiagnosisProps {
    score: number;
    title: string;
    classification_of_score?: ClassificationItem[];
}

// Função para interpolar uma cor entre duas (verde → vermelho)
const interpolateColor = (start: string, end: string, factor: number): string => {
    const hexToRgb = (hex: string) =>
        hex.match(/\w\w/g)?.map((x) => parseInt(x, 16)) ?? [0, 0, 0];

    const rgbToHex = (rgb: number[]) =>
        '#' + rgb.map((x) => x.toString(16).padStart(2, '0')).join('');

    const startRGB = hexToRgb(start);
    const endRGB = hexToRgb(end);
    const result = startRGB.map((startC, i) =>
        Math.round(startC + factor * (endRGB[i] - startC))
    );

    return rgbToHex(result);
};

// Constrói as faixas com cor interpolada entre verde e vermelho
const buildFaixas = (classification: ClassificationItem[]): {
    label: string;
    cor: string;
    min: number;
    max: number;
}[] => {
    const startColor = '#90EE90'; // verde claro
    const endColor = '#FF7F7F';   // vermelho claro
    const count = classification.length;

    return classification.map((item, index) => {
        const regex = /(\d+(?:\.\d+)?)/g;
        const nums = item.condition.match(regex);
        let min = 0, max = 0;
        if (nums && nums.length >= 2) {
            min = Math.max(0, parseFloat(nums[0]) - 0.5);
            max = parseFloat(nums[1]) + (index < classification.length - 1 ? 0.5 : 0);
        }

        const cor = interpolateColor(startColor, endColor, index / (count - 1));

        return {
            label: item.value,
            cor,
            min,
            max,
        };
    });
};

// Avalia em qual faixa o score se encaixa
const getScoreCategoria = (score: number, classification: ClassificationItem[]): string => {
    for (const item of classification) {
        try {
            const condition = item.condition.replace(/score/g, score.toString());
            if (eval(condition)) {
                return item.value;
            }
        } catch (e) {
            console.warn('Erro ao processar condição:', item.condition);
        }
    }
    return 'Não classificado';
};

const FormDiagnosis: React.FC<FormDiagnosisProps> = ({ score, title, classification_of_score }) => {
    if (score == null) return null;

    let categoria = 'Não classificado';
    let faixas: {
        label: string;
        cor: string;
        min: number;
        max: number;
    }[] = [];


    if (classification_of_score && classification_of_score?.length > 0) {
        categoria = getScoreCategoria(score, classification_of_score);
        faixas = buildFaixas(classification_of_score);
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                {title}: {score} {categoria !== 'Não classificado' ? `(${categoria})` : ''}
            </div>
            {classification_of_score && (
                <RangeIndicatorChart
                    value={score}
                    title={title}
                    faixas={faixas}
                />
            )}
        </div>
    );
};

export default FormDiagnosis;
